<template>
  <div id="dfx-apply">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      ready: false,
    };
  },
  mounted() {},
};
</script>

<style lang="scss"></style>
